import gql from 'graphql-tag';

export default gql`
  query borderControlRequirements(
    $origin: BoundInput!
    $destination: BoundInput!
    $document: String!
    $market: Market!
    $language: Language!
    $isReturnJourney: Boolean
    $isLongTermStayOrResidencyEeaSwiss: Boolean
    $isLongTermStayOrResidencyUk: Boolean
  ) {
    borderControlRequirements(
      origin: $origin
      destination: $destination
      document: $document
      market: $market
      language: $language
      isReturnJourney: $isReturnJourney
      isLongTermStayOrResidencyEeaSwiss: $isLongTermStayOrResidencyEeaSwiss
      isLongTermStayOrResidencyUk: $isLongTermStayOrResidencyUk
    ) {
      outbound {
        ees {
          title
          requirements {
            ... on BorderControlRequirementGroup {
              title
              subTitle
              primaryBody
            }
          }
        }
        visaOrTravelAuth {
          title
          requirements {
            ... on BorderControlRequirementGroup {
              title
              subTitle
              primaryBody
            }
          }
        }
        idDocsAndApi {
          title
          requirements {
            ... on BorderControlRequirementGroup {
              title
              subTitle
              primaryBody
            }
          }
        }
      }
      inbound {
        ees {
          title
          requirements {
            ... on BorderControlRequirementGroup {
              title
              subTitle
              primaryBody
            }
          }
        }
        visaOrTravelAuth {
          title
          requirements {
            ... on BorderControlRequirementGroup {
              title
              subTitle
              primaryBody
            }
          }
        }
        idDocsAndApi {
          title
          requirements {
            ... on BorderControlRequirementGroup {
              title
              subTitle
              primaryBody
            }
          }
        }
      }
    }
  }
`;
